export default {"src":"/_next/static/media/bulb.67a1b1eb.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};